import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

import pricing_tool_banner_deep768x346 from "Custom/Content/User/pricing_tool_banner_deep-768x346.jpg";
import pricing_tool_banner_deep from "Custom/Content/User/pricing_tool_banner_deep.jpg";

export const UserPageHeader: any = styled(Box)`
    background-color: #fff;
    height: 300px;
    min-width: "100%";
    background-attachment: scroll;
    background-size: cover;
    background-repeat: none !important; // Why does material UI overwrite this?
    background-origin: padding-box;
    background-position-x: center;
    background-position-y: center;
    display: block;
    padding-left: 15px;
    padding-right: 15px;
    background-size: auto;

    @media only screen and (max-width: ${breakpointTheme.breakpoints.values.md + "px"}) {
        height: 200px;
        background-image: url(${pricing_tool_banner_deep768x346});
        background-size: cover;
        background-repeat: none !important; // Why does material UI overwrite this?
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.md + "px"}) and (max-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        height: 200px;
        background-image: url(${pricing_tool_banner_deep768x346});
        background-size: cover;
        background-repeat: none !important; // Why does material UI overwrite this?
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        height: 300px;
        background-image: url(${pricing_tool_banner_deep});
    }
`;
